/* istanbul ignore file */

import { canAccessBroadcast } from './ducks/selectors';

export const mapStateToProps = (state: BaseStore) => ({
    isAllowed: canAccessBroadcast(state),
});
